import { toast } from 'react-toastify';
import {
  operateUpdateSettingEntityApiCall,
  SettingsEntityType,
} from './settings-entity-types';
import globalSettingsStores from '../../../../stores/settings-stores';

export const updateEntityNameOperation = async (
  entityType: SettingsEntityType,
  entityId: number,
  entityName: string,
  setLoading: (loading: boolean) => any,
) => {
  try {
    if (entityName.length < 3 || entityName.length > 50) {
      toast.warn('יש להזין שם בין 3 ל- 60 תווים.');
      return;
    }

    setLoading(true);
    await operateUpdateSettingEntityApiCall(entityType, entityId, entityName);
    globalSettingsStores.fetchSetting();
    setLoading(false);
  } catch (e) {
    setLoading(false);
    console.error(
      `updateEntityNameOperation is failed with the entityType: ${entityType} entityName: ${entityName} and the error: ${e}`,
    );
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
  }
};
